module.exports = __webpack_public_path__ + "static/media/hover.ee31b0d5.png";